module.exports = __webpack_public_path__ + "static/media/user-avatar.8025570a.svg";